export default "__VITE_ASSET__b9299e9b__"